import React from 'react';
import { useLocation } from 'react-router-dom';
import { sortBy, prop } from 'ramda';
import { appRoutes } from 'routes';
import useScreen from 'hooks/useScreen';

import DesktopMenu from './components/DesktopMenu';
import MobileMenu from './components/MobileMenu';

const DESKTOP_MENU_ITEMS = [
  {
    name: 'survey',
    label: 'layouts.NonAuthLayout.Menu.freeQuotes',
    path: appRoutes.surveyPath(),
    order: 1,
  },
  {
    name: 'calculators',
    label: 'layouts.NonAuthLayout.Menu.calculators',
    path: appRoutes.calculatorsPath(),
    order: 2,
  },
  {
    name: 'budget',
    label: 'layouts.NonAuthLayout.Menu.budget',
    path: appRoutes.quizPath(),
    order: 2,
  },
];

const Menu = () => {
  const { isDesktop } = useScreen();
  const { pathname } = useLocation();

  const isCurrentLocation = currentPath => pathname === currentPath;

  const menuItems = sortBy(prop('order'), DESKTOP_MENU_ITEMS).map(item => ({
    ...item,
    isActive: isCurrentLocation(item.path),
  }));

  return isDesktop ? <DesktopMenu menuItems={menuItems} /> : <MobileMenu />;
};

export default Menu;



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/Menu.js